import { render, staticRenderFns } from "./SalDispatchList.vue?vue&type=template&id=91473c50&scoped=true&"
import script from "./SalDispatchList.vue?vue&type=script&lang=js&"
export * from "./SalDispatchList.vue?vue&type=script&lang=js&"
import style0 from "./SalDispatchList.vue?vue&type=style&index=0&id=91473c50&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91473c50",
  null
  
)

export default component.exports